import { useQuery } from "@tanstack/react-query";
import { fetchMaintenanceStatus } from "../lib/fetchers";
import { maintenanceKeys } from "./queryKeys";

export function useMaintenanceStatusQuery() {
  return useQuery({
    queryKey: maintenanceKeys.status(),
    queryFn: () => fetchMaintenanceStatus(),
    staleTime: 30000, // 30 seconds
    refetchInterval: 30000, // Check every 30 seconds
    retry: 2,
    retryDelay: 1000,
  });
}
